import Vue from 'vue';
import Component from "vue-class-component";
import Slick from 'vue-slick';
@Component({
    components: {
        Slick,
    }
})
export class BasicSlider extends Vue {
    
    public slickOptionsSlider: any = {
        rows: 0,
        slidesToShow: 4,
        slidesToScroll: 4,
        lazyLoad: 'ondemand',
        // nextArrow: '<a href="javascript:void()" class="slick-next slick-arrow"><i class="icon-angle-right" aria-hidden="true"></a></a>',
        // prevArrow: '<a href="javascript:void()" class="slick-prev slick-arrow"><i class="icon-angle-left" aria-hidden="true"></a></a>',
        dots: true,
        arrows: true,
        fade: false,
        infinite: true,
        adaptiveHeight: false,
        responsive: [
            {
                breakpoint: 1025,
                settings: {
                    slidesToShow: 4,
                    slidesToScroll: 4
                }
            },
            {
                breakpoint: 869,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 3
                }
            },
            {
                breakpoint: 660,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2,
                    dots: false
                    //swipeToSlide: true
                }
            },
            {
                breakpoint: 410,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    dots: false
                    //swipeToSlide: true
                }
            }
        ]
    };
}
Vue.component("basic-slider", BasicSlider);
